module.exports = __webpack_public_path__ + "img/collection-weddingRingsFrameSettings.87baae1.jpg";